import React from "react";
import ContentCardBody from "../../common/template/contentCardBody";
import Row from "../../common/layout/row";
import Grid from "../../common/layout/grid";
import Table from "../../common/table/table";
import THead from "../../common/table/tHead";
import Th from "../../common/table/th";
import TBody from "../../common/table/tBody";
import Td from "../../common/table/td";
import Button from "../../common/button/button";
import { ModalAlert } from "../../common/dialog/modalAlert.jsx";
import NewTr from "../../common/table/newTr.jsx";

export function ModalFaturasNaoImportadas(props) {
    if (!props.listaModalFaturasSemImportacao.length) return null;

    return (
        <ModalAlert titulo="Faturas Não Importadas" handleClose={props.handleClose}>
            <ContentCardBody style={{ marginBlock: 20 }}>
                <div className="custom-scroll" style={{ borderRadius: "0.3rem", overflow: "hidden", border: "1px solid #DDD" }}>
                    <Table responsive>
                        <THead>
                            <Th>
                                <div className="pl-2">Unidade Consumidora</div>
                            </Th>
                            <Th>Competência</Th>
                        </THead>
                        <TBody>
                            {props.listaModalFaturasSemImportacao.map((item, iTr) => (
                                <NewTr noButtons backgroundColorTr={iTr % 2 == 0 ? "#DDD" : "#EEE"}>
                                    <Td>
                                        <div className="pl-2">{item.nome_unidade_consumidora}</div>
                                    </Td>
                                    <Td alignCenter width={100}>
                                        {String(item.competencia).substring(4, 6) + "/" + String(item.competencia).substring(0, 4)}
                                    </Td>
                                </NewTr>
                            ))}
                        </TBody>
                    </Table>
                    {props.usuarioLogado.administrador && (
                        <Row alignCenter style={{ paddingRight: 5 }}>
                            <Grid cols="12 12 4 4" style={{ display: "flex", justifyContent: "center" }}>
                                <Button
                                    text={<span style={{ fontSize: "clamp(0.6rem, 2vw, 0.8rem)", whiteSpace: "nowrap" }}>Verificar</span>}
                                    title="Verificar"
                                    type={"primary"}
                                    icon={"fa fa-search"}
                                    event={props.handleVerificarFaturas}
                                />
                            </Grid>
                        </Row>
                    )}
                </div>
            </ContentCardBody>
        </ModalAlert>
    );
}
